import { PersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { usePregeneratedHashes } from 'graphql-codegen-persisted-query-ids/lib/apollo'

export const makeApolloPersistedOperationsLink = (hashes) => {
    return new PersistedQueryLink({
        generateHash: usePregeneratedHashes(hashes) as PersistedQueryLink.GenerateHashFunction,
    })
}
